let html = `
<svg><use xlink:href="#sprite-settings"></use></svg>
`

export default html